export const DETAIL_ACTIVITY_PAGE_SIZE = 25;
export const GLOBAL_ACTIVITY_PAGE_SIZE = 50;

export function normalizeActivityPageResponse(data) {
  const items = Array.isArray(data?.items) ? data.items : null;
  const hasMore = typeof data?.has_more === "boolean" ? data.has_more : null;
  const nextCursor = data?.next_cursor ?? null;

  if (!items || hasMore === null) {
    throw new Error("Unerwartete Activities-Antwort.");
  }

  if (
    hasMore &&
    (!nextCursor || typeof nextCursor.created_at !== "string" || typeof nextCursor.id !== "string")
  ) {
    throw new Error("Unvollständiger Activities-Cursor.");
  }

  return {
    items,
    hasMore,
    nextCursor:
      nextCursor && nextCursor.created_at && nextCursor.id
        ? { created_at: nextCursor.created_at, id: nextCursor.id }
        : null,
  };
}

export function mergeActivities(existing, incoming) {
  const seen = new Set();
  const merged = [];
  for (const item of [...(existing || []), ...(incoming || [])]) {
    if (!item?.id || seen.has(item.id)) continue;
    seen.add(item.id);
    merged.push(item);
  }
  return merged;
}
